module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"acceptLabel":"YES","closeLabel":"NO"},"es":{"acceptLabel":"SI","closeLabel":"NO"}}')
  delete Component.options._Ctor
}
